import SvgIcon from '@mui/material/SvgIcon';
import React from 'react'

// ...
class LogoutIcon extends React.PureComponent {
	render() {
			return (
				  	<SvgIcon>
				    	<path d="M16,17V14H9V10H16V7L21,12L16,17M14,2A2,2 0 0,1 16,4V6H14V4H5V20H14V18H16V20A2,2 0 0,1 14,22H5A2,2 0 0,1 3,20V4A2,2 0 0,1 5,2H14Z" />
				  	</SvgIcon>
				)
		}
}

export default LogoutIcon